// import api from '@/api/contents';
import api from '@/api/settings';

const setUserSelectedLanguage = (context, lang) => {
  context.commit('SET_USER_SELECTED_LANGUAGE', lang);
};

const setUserSelectedLevel = (context, level) => {
  context.commit('SET_USER_SELECTED_LEVEL', level);
};

const setUserOverwriteBrowserLanguagePersisted = (context, value) => {
  context.commit('SET_OVERWRITE_BROWSER_LANGUAGE_PERSISTED', value);
};

const setUserSelectedGoal = (context, goal) => {
  context.commit('SET_USER_SELECTED_GOAL', goal);
};

const setLessonSoundEnabled = (context, soundEnabled) => {
  context.commit('SET_LESSON_SOUND_ENABLED', soundEnabled);
};

const setLessonSlowSoundEnabled = (context, enabled) => {
  context.commit('SET_LESSON_SLOW_SOUND_ENABLED', enabled);
};

const setLessonMotivationEnabled = (context, enabled) => {
  context.commit('SET_LESSON_MOTIVATION_ENABLED', enabled);
};

const setStartFromClass = (context, value) => {
  context.commit('START_FROM_CLASS', value);
};

const fetchAbTestUserOption = (context, cookieKey) =>
  new Promise((resolve, reject) => {
    const apiLevel = 1;
    api
      .fetchAbTestOptions(apiLevel, cookieKey)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });

const setUserSettings = (context, { id, value }) => {
  const apiLevel = 1;
  value = value == null ? true : value;
  api.setUserSettings(apiLevel, id, value);
  context.commit('SET_USER_SETTINGS', { id, value });
};

const setNotificationInfo = (context, notificationEnabled) => {
  context.commit('SET_NOTIFICATION_ENABLED', notificationEnabled);
};

const getUserSettingsFromServer = context =>
  new Promise((resolve, reject) => {
    const apiLevel = 1;
    api
      .fetchUserSettings(apiLevel)
      .then((response) => {
        context.commit('SET_ALL_USER_SETTINGS', response);
        resolve(response);
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error(error);
        reject(error);
      });
  });

const setTeachBotSpeed = (context, speed) => {
  context.commit('SET_TEACH_BOT_SPEED', speed);
};

const setPageNotFound = (context, value) => {
  context.commit('SET_PAGE_NOT_FOUND', value);
};

const setNeedLastLearnedCard = (context, value) => {
  context.commit('SET_LAST_LEARNED_CARD', value);
};

const setProPopupType = (context, value) => {
  context.commit('SET_PRO_POPUP_TYPE', value);
};

const setIsNexusUser = (context, value) => {
  context.commit('SET_IS_NEXUS_USER', value);
};
const setLastRoute = (context, value) => {
  context.commit('SET_LAST_ROUTE', value);
};

const setSelectedLearnedLanguage = (context, lang) => {
  context.commit('SET_SELECTED_LEARNED_LANGUAGE', lang);
};

const setDktOptions = (context, value) => {
  context.commit('SET_DKT_OPTIONS', value);
};

const setMobileSupportModalStatus = (context, value) => {
  context.commit('SET_MOBILE_SUPPORT_MODAL_STATUS', value);
};

const setInvalidationStatus = (context, value) => {
  context.commit('SET_INVALIDATION_STATUS', value);
};

const setWindowWidthMobile = (context, value) => {
  context.commit('SET_WINDOW_WIDTH_MOBILE', value);
};

const setWindowWidth = (context, value) => {
  context.commit('SET_WINDOW_WIDTH', value);
};

const setWCAGSetting = (context, object) => {
  context.commit('SET_WCAG_SETTING', object);
};

const setIsKHUser = (context, value) => {
  context.commit('SET_IS_KH_USER', value);
};

export default {
  setUserSelectedLanguage,
  setSelectedLearnedLanguage,
  setUserSelectedLevel,
  setUserOverwriteBrowserLanguagePersisted,
  setUserSelectedGoal,
  setLessonSoundEnabled,
  setUserSettings,
  getUserSettingsFromServer,
  setTeachBotSpeed,
  setNotificationInfo,
  fetchAbTestUserOption,
  setLessonSlowSoundEnabled,
  setLessonMotivationEnabled,
  setStartFromClass,
  setPageNotFound,
  setNeedLastLearnedCard,
  setProPopupType,
  setIsNexusUser,
  setLastRoute,
  setDktOptions,
  setInvalidationStatus,
  setWindowWidthMobile,
  setWindowWidth,
  setMobileSupportModalStatus,
  setWCAGSetting,
  setIsKHUser,
};
